<template lang="pug">
	.license-requests-mapping.tb-padding
		Popup(v-if="popupVisible && licenseRequestId", :popupVisible="popupVisible", @hiding="$emit('close')", :height="300", :width="680")
			Loader(v-if="isLoading", :text="$tCaption('Loading')")
			template(v-else)
				.flex-col.space-large
					.flex-col.space
						.font-large {{$tCaption('Stations')}}
						span {{$tCaption('Please select an existing stations or create a new one.')}}
					.flex-col.space-large
						.station-selection.flex-col.center
							.flex-row
								Dropdown.selector.flex-1(
									ref="dd",
									:getTotal="r => r.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="(a,b,c) => $Data.getExternalStations(a,b,{...c, allCountries: false, allStations: false })",
									:columns="[{ dataField: 'Name', caption: $tCaption('Station') }]",
									displayExpr="Name",
									valueExpr="Oid",
									:placeholder="$tCaption('Select stations')",
									v-model="requestStations",
									:showColumnHeaders="false",
									:filtersVisible="false",
									:searchVisible="true",
									:multiple="true",
									:minSearchLength="0")
								DxButton(icon="plus", @click="() => createStation()")
			.flex-row.space(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="popupVisible = false")
				DxButton(:text="$tCaption('Save', '@actions')", type="default", @click="() => save()", :disabled="!requestStations.length || isLoading")
		Popup(v-if="newStationPopupVisible", :popupVisible="newStationPopupVisible", :closeOnOutsideClick="false")
			NewStationDetail(ref="newStation", id="new", @created="setCreatedStation", :preventRedirect="true", :saveButtonHidden="true")
			.flex-row.space(slot="actions-right")
				DxButton(:text="$tCaption('Save', '@actions')", type="success", @click="() => saveNewStation()")
				DxButton(:text="$tCaption('Close', '@actions')", @click="() => newStationPopupVisible = false")
</template>

<script>
import DxButton from 'devextreme-vue/button';
import Loader from 'app-core/Loader.vue';
import Popup from 'app-core/Popup.vue';
import Dropdown from 'app-core/Dropdown.vue';
import NewStationDetail from 'view/station/Detail.vue';

export default {
	translationCategory: 'user.LicenseRequestMapping',
	components: { DxButton, Loader, Popup, Dropdown, NewStationDetail },
	props: ['licenseRequestId'],
	data() {
		return {
			popupVisible: false,
			isLoading: false,
			requestStations: [],
			newStationPopupVisible: false,
			isLoadingRequestStations: false
		};
	},
	watch: {
		'licenseRequestId'(v) {
			if (v)
				this.show(true);
		}
	},
	mounted() {
		if (__DEBUG__)
			window.requestMapping = this;
		if (this.licenseRequestId)
			this.show(true);
	},
	methods: {
		show(v) {
			this.popupVisible = false;
			if (v)
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.popupVisible = true;
					this.loadRequestStations();
				});
			else
				this.$emit('close');
		},
		save() {
			this.$confirmMessage({
				title: this.$tCaption('Confirm action', '@actions'),
				text: this.$tCaption(`Are you sure you want to submit license request?`),
				handler: () => {
					this.isLoading = true;
					this.$Data.postExternalApi('Company/UpdateStationsInLicense', {
						LicenseRequestId: this.licenseRequestId,
						StationIds: this.requestStations
					}).then(r => {
						if (r.Success) {
							this.$Data.getExternalApi('Company/SubmitLicenseForApprove', `licenseRequestId=${this.licenseRequestId}`).then(r => {
								if (r.Success) {
									this.$notifySuccess(this.$tCaption('Request has been successfully submitted'));
									this.$emit('submit');
									this.show(false);
								} else {
									this.$notifyError(r.ErrorMessage);
								};
							}).finally(() => this.isLoading = false);
						} else {
							this.isLoading = false;
							this.$notifyError(r.ErrorMessage);
						}
					}).catch(() => this.isLoading = false);

				}
			});
		},
		loadRequestStations() {
			this.requestStations = [];
			this.isLoading = true;
			this.isLoadingRequestStations = true;
			this.$Data.getExternalApi('Company/GetStationsFromLicenseRequest', `licenseRequestId=${this.licenseRequestId}`, 999).then(r => {
				if (__DEBUG__)
					console.debug('Request stations loaded', { r });
				if (!r.ErrorMessage) {
					this.requestStations = r.Results.map(f => f.Oid);
				} else {
					this.$notifyError(r.ErrorMessage);
				}
			}).finally(() => {
				this.isLoading = false;
				this.isLoadingRequestStations = false;
			});
		},
		createStation(request) {
			this.newStationPopupVisible = false;
			setImmediate(() => {
				if (this._isDestroyed) return;
				this.newStationPopupVisible = true;
			});
		},
		setCreatedStation(station) {
			this.requestStations.push(station.Oid);
			this.newStationPopupVisible = false;
			this.$refs.dd.reload();
		},
		saveNewStation() {
			this.$refs.newStation.save();
		}
	}
};
</script>
<style lang="scss">
	.license-requests-mapping {

	}
</style>
